import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { GlobalsService } from 'src/app/services/globals/globals.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-termins-and-conditions-template-sheet',
  templateUrl: './termins-and-conditions-template-sheet.component.html',
  styleUrls: ['./termins-and-conditions-template-sheet.component.scss']
})
export class TerminsAndConditionsTemplateSheetComponent implements OnInit {
  public sys: string;
  public lottoSubs: Subscription;

  constructor(private _bottomSheetRef: MatBottomSheetRef<TerminsAndConditionsTemplateSheetComponent>, private _globals: GlobalsService) {}

  closeTerminsAndConditions(): void {
    this._bottomSheetRef.dismiss();
  }

  ngOnInit(): void {
    this.setSysAndLang();
  }

  setSysAndLang(): void {
    this.sys = this._globals.getSystem().site;
  }
}
